import React, { useEffect, useState } from "react";
import imageUrlBuilder from "@sanity/image-url";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { getSanityClient } from "../sanintyClient";

const client = getSanityClient();

const { projectId, dataset } = client.config();
const postImage = (source) =>
  projectId && dataset
    ? imageUrlBuilder({ projectId, dataset }).image(source)
    : null;

function BlogsHome() {
  const [allPostsData, setAllPosts] = useState(null);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "blogPost"]{ _id, title, content, slug, author, publishedAt, mainImage, categories, excerpt }`
      )
      .then((data) => setAllPosts(data))
      .catch((err) => console.error(err));
  }, []);

  return (
    <section className="blog-area pt-110 pb-60">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-9">
            <div className="section-title text-center mb-65">
              <div className="section-icon">
                <img src="img/icon/pawprint.png" alt="" />
              </div>
              <h5 className="sub-title">Nuestra actualidad</h5>
              <h2 className="title">Últimas novedades</h2>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          {Array.isArray(allPostsData) && allPostsData.length > 0 ? (
            allPostsData.map((item) => (
              <div className="col-lg-4 col-md-6" key={item._id}>
                <div className="blog-post-item mb-50">
                  <div className="blog-post-thumb">
                    <Link to={`/blog/${item._id}`}>
                      <img
                        src={postImage(item.mainImage.asset._ref)}
                        alt={item.title}
                      />
                    </Link>
                  </div>
                  <div className="blog-post-content">
                    <div className="blog-post-meta">
                      <ul>
                        <li>
                          <i className="far fa-user" />
                          <Link to="/">{item.author || "Admin"}</Link>
                        </li>
                        <li>
                          <i className="far fa-bell" />{" "}
                          {format(item.publishedAt, "MMMM dd, yyyy")}
                        </li>
                      </ul>
                    </div>
                    <h3 className="title">
                      <Link to={`/blog/${item._id}`}>
                        {item.title || "Working For Dog Adoption"}
                      </Link>
                    </h3>
                    <p>
                      {item.excerpt ||
                        "The best overall dog test is Embark Breed & Health Kit view at Chewy."}
                    </p>
                    <Link to={`/blog/${item._id}`} className="read-more">
                      Leer Post <img src="img/icon/pawprint.png" alt="" />
                    </Link>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div>No posts available.</div>
          )}
        </div>
      </div>
    </section>
  );
}

export default BlogsHome;
